import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 5px 0 40px 0;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;